import o from "./HeaderListbox.vue2.js";
import "./HeaderListbox.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const e = /* @__PURE__ */ t(o, [["__scopeId", "data-v-11addf26"]]);
export {
  e as default
};
